import { render } from "./App.vue?vue&type=template&id=cecbbe8a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=cecbbe8a&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__